class MiniCartReviews extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
    this.prevButton = null;
    this.nextButton = null;
    this.swiperContainer = null;
  }

  connectedCallback() {
    this.init();
  }

  init() {
    // Get swiper elements
    this.swiperContainer = this.querySelector('.mini-cart-reviews-slider');
    this.prevButton = this.querySelector('.mini-cart-reviews-header-arrow.prev');
    this.nextButton = this.querySelector('.mini-cart-reviews-header-arrow.next');

    if (!this.swiperContainer) return;

    // Initialize Swiper slider
    this.initSwiper();
    this.bindCustomButtons();
  }

  initSwiper() {
    // Destroy existing swiper if it exists
    if (this.swiper) {
      this.swiper.destroy(true, true);
    }

    // Initialize new Swiper instance
    this.swiper = new Swiper(this.swiperContainer, {
      slidesPerView: 1,
      spaceBetween: 12,
      loop: true,
      speed: 300,
      effect: 'slide',
      allowTouchMove: true,
      
      // Scrollbar
      scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
        dragSize: 'auto',
      },
      
      // Disable default navigation since we use custom buttons
      navigation: false,
      
      // Auto height for variable content
      autoHeight: false,
      
      // Breakpoints for responsive design
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 12,
        },
        768: {
          slidesPerView: 1,
          spaceBetween: 12,
        }
      },
      
      // Events
      on: {
        init: () => {
          this.updateButtonStates();
        },
        slideChange: () => {
          this.updateButtonStates();
        }
      }
    });
  }

  bindCustomButtons() {
    // Bind custom prev button
    if (this.prevButton) {
      this.prevButton.addEventListener('click', (e) => {
        e.preventDefault();
        if (this.swiper) {
          this.swiper.slidePrev();
        }
      });
    }

    // Bind custom next button
    if (this.nextButton) {
      this.nextButton.addEventListener('click', (e) => {
        e.preventDefault();
        if (this.swiper) {
          this.swiper.slideNext();
        }
      });
    }
  }

  updateButtonStates() {
    if (!this.prevButton || !this.nextButton || !this.swiper) return;

    // For loop mode, keep buttons always enabled
    this.prevButton.style.opacity = '1';
    this.prevButton.style.pointerEvents = 'auto';
    this.prevButton.style.cursor = 'pointer';
    
    this.nextButton.style.opacity = '1';
    this.nextButton.style.pointerEvents = 'auto';
    this.nextButton.style.cursor = 'pointer';
  }

  // Method to reinitialize when cart content updates
  refresh() {
    // Small delay to ensure DOM is updated
    setTimeout(() => {
      this.init();
    }, 50);
  }

  // Cleanup method
  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }
}

// Define the custom element
customElements.define('mini-cart-reviews', MiniCartReviews);

class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');
          
        // Initialize mini-cart reviews after content is loaded
        this.initializeMiniCartReviews();
        
        // Initialize timer after content is loaded
        this.initializeTimer();
          
        document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      })
      .catch(e => {
        console.error(e);
      });
  }

  open() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }
    
    this.drawer.openMenuDrawer();
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      if (document.getElementById(section.id)) {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));

    // Initialize mini-cart reviews after content update
    this.initializeMiniCartReviews();
    
    // Initialize timer after content update
    this.initializeTimer();

    this.open();
  }

  // ...existing code...

  initializeMiniCartReviews() {
    // Wait for DOM to be fully updated
    setTimeout(() => {
      const miniCartReviews = document.querySelector('mini-cart-reviews');
      if (miniCartReviews) {
        // If the element already exists, refresh it
        if (typeof miniCartReviews.refresh === 'function') {
          miniCartReviews.refresh();
        } else {
          // If it's a new element, it will auto-initialize
          console.log('Mini-cart reviews initialized');
        }
      }
    }, 100);
  }

  initializeTimer() {
    // Wait for DOM to be fully updated
    setTimeout(() => {
      // Clear any existing timer interval
      if (this.timerInterval) {
        clearInterval(this.timerInterval);
        this.timerInterval = null;
      }
      
      // Find timer within the mini-cart section specifically
      const miniCartSection = document.getElementById('mini-cart');
      if (!miniCartSection) return;
      
      const timerEl = miniCartSection.querySelector('.js-timer');
      if (timerEl) {
        this.updateTimer(timerEl);
        // Update every second
        this.timerInterval = setInterval(() => this.updateTimer(timerEl), 1000);
      }
    }, 100);
  }

  updateTimer(timerEl) {
    const daysEl = timerEl.querySelector('.js-days');
    const hoursEl = timerEl.querySelector('.js-hours');
    const minutesEl = timerEl.querySelector('.js-minutes');
    const secondsEl = timerEl.querySelector('.js-seconds');
    const timerText = timerEl.dataset.timerText;
    const mode = timerEl.dataset.mode;
    
    if (!daysEl || !hoursEl || !minutesEl || !secondsEl) return;

    const now = new Date();
    const targetDate = this.resolveTargetDate(now, mode, timerText);
    const diff = targetDate - now;

    if (diff > 0) {
      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);

      daysEl.textContent = days < 10 ? `0${days}` : String(days);
      hoursEl.textContent = hours < 10 ? `0${hours}` : String(hours);
      minutesEl.textContent = minutes < 10 ? `0${minutes}` : String(minutes);
      secondsEl.textContent = seconds < 10 ? `0${seconds}` : String(seconds);
    } else {
      daysEl.textContent = '00';
      hoursEl.textContent = '00';
      minutesEl.textContent = '00';
      secondsEl.textContent = '00';
    }
  }

  resolveTargetDate(now, mode, timerText) {
    switch (mode) {
      case 'day': {
        const d = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
        d.setHours(0,0,0,0);
        return d;
      }
      case 'week': {
        let daysUntilNextMonday = (7 - now.getDay() + 1) % 7;
        if (daysUntilNextMonday === 0) daysUntilNextMonday = 7;
        const d = new Date(now.getFullYear(), now.getMonth(), now.getDate() + daysUntilNextMonday);
        d.setHours(0,0,0,0);
        return d;
      }
      case 'month':
        return new Date(now.getFullYear(), now.getMonth() + 1, 1);
      case 'date': {
        const d = new Date(timerText);
        if (isNaN(d.getTime()) || d <= now) {
          const fallback = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
          fallback.setHours(0,0,0,0);
          return fallback;
        }
        return d;
      }
      default:
        return new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  disconnectedCallback() {
    // Clean up timer interval when element is removed
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
      this.timerInterval = null;
    }
  }
}

customElements.define('mini-cart', MiniCart);
